import GitCommit from '../_git_commit';
import configuration from '../configuration/server';

export function frontEndVersion() {
    const { STAGE } = configuration;
    return configuration[STAGE] && configuration[STAGE].feVersion;
}

export function frontEndCommitHash() {
    return GitCommit.logMessage.split(' ')[0];
}

export function backEndStage() {
    return configuration.STAGE;
}



// WEBPACK FOOTER //
// ./src/utilities/version.jsx